var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sky-charts',{ref:"chart",attrs:{"api-conf":_vm.apiConf,"queryCondition":_vm.condition,"config":_vm.chartConfig,"extend":_vm.extend}})
}
var staticRenderFns = []

export { render, staticRenderFns }